/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultProduct } from '../../models/api-response-paged-result-product';
import { PagedRequestProduct } from '../../models/paged-request-product';

export interface SearchProduct$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestProduct
}

export function searchProduct(http: HttpClient, rootUrl: string, params: SearchProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultProduct>> {
  const rb = new RequestBuilder(rootUrl, searchProduct.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultProduct>;
    })
  );
}

searchProduct.PATH = '/v1/api/products/search';
